import gql from 'graphql-tag';

export const ListHelpQuery = gql`
  query ListHelpQuery {
    helpTexts {
      id
      topicCode
      topicCodeOptionSet
      includeInHelpPanel
      name
      linkText
      question
      answer
    }
  }
`;

export const GetHelpByIdQuery = gql`
  query GetHelpByIdQuery($id: String){
    helpTexts(id: $id) {
      id
      topicCode
      topicCodeOptionSet
      includeInHelpPanel
      name
      linkText
      question
      answer
    }
  }
`;
